import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export const WhatsAppButton = () => {
    const [number, setNumber] = useState("");
    useEffect(() => {
        api.get("/settings").then((r) => setNumber(r.data?.whatsapp_number || "")).catch(() => {});
    }, []);
    const clean = (number || "").replace(/[^\d]/g, "");
    if (!clean) return null;
    const href = `https://wa.me/${clean}?text=${encodeURIComponent("Hello, I would like to know more about Gaurav Sankalp Phase-1 Association.")}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-float-btn"
            className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-brand-orange text-white shadow-xl transition-transform hover:scale-105"
        >
            <MessageCircle size={26} />
        </a>
    );
};

export default WhatsAppButton;
